import navigation from "@/lang/de/navigation";
import generics from "@/lang/de/generics";
import questions from "@/lang/de/questions";
import a11y from "@/lang/de/a11y";
import velt from "@/lang/de/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
